import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import httpTools from '@/lib/utils/shared/httpTools'

export interface HydraCheckIfEmailIsTakenProps {
  email: string
}

export const HydraCheckIfEmailIsTaken = async ({
  email,
}: HydraCheckIfEmailIsTakenProps) => {
  const request: SendRequestType = {
    method: 'HEAD',
    url: `/customers?email=${email}`,
    withAuth: false,
    returnType: 'response',
  }

  return httpTools.sendRequest<Response>(request)
}
